export const FAQ_CATEGORIES = [
  {
    id: "website-marketing",
    title: "Website Marketing",
    faqs: [
      {
        q: "How much is website marketing? How do I budget?",
        a: [
          {
            type: "p",
            text: "Website marketing can cost however much you want to spend. As with most things, the larger your budget, the more you can do with your marketing. It should be proportional to your overall marketing budget.",
          },
        ],
      },
      {
        q: "How do I get started marketing my business website?",
        a: [
          {
            type: "p",
            text: "Start by taking a look at your current online marketing strategies. In an organized way, start a series of documents that will help you track and manage your marketing efforts. Document a baseline position of your business and the metrics that are important for your business. Set your first goals and start looking for help to manage your marketing. Find an online marketing professional via referral or research. Decide on a marketing budget for advertising or marketing tools.",
          },
        ],
      },
      {
        q: "How can you tell if online marketing is working?",
        a: [
          {
            type: "p",
            text: "The most common way is by using Google Analytics. Because Google ranks web pages for keywords, your site could have several pages that rank for a variety of different search phrases. By monitoring your Google rankings and watching the actual traffic to your website, you can see the effectiveness of your online marketing.",
          },
        ],
      },
      {
        q: "Do I have to hire an agency to market my business effectively?",
        a: [
          {
            type: "p",
            text: "Not if you know what you are doing in all aspects of the marketing. But by hiring a marketing agency, you are getting a very diverse skill set and knowledge at your service. That means the agency will be able to accomplish your marketing goals efficiently and give you advice on how to strengthen your online marketing efforts.",
          },
        ],
      },
    ],
  },
  {
    id: "seo",
    title: "SEO",
    faqs: [
      {
        q: "How much SEO do I need?",
        a: [
          {
            type: "p",
            text: "The amount of SEO you choose to utilize should be proportionate to your marketing campaign budget. A comprehensive SEO campaign will involve a combination of technical SEO, content marketing, and link building.",
          },
        ],
      },
      {
        q: "Does SEO even work anymore?",
        a: [
          {
            type: "p",
            text: "The truth is, yes, SEO is every bit as important as it's always been — there have just been a lot of changes to how it works recently. Good SEO will always be a benefit to any website. When SEO is done correctly, it will always affect the results of your SEO efforts.",
          },
        ],
      },
      {
        q: "How much should I spend on SEO?",
        a: [
          {
            type: "p",
            text: "It comes down to a matter of positioning — how does your website compare to your competitors? That position and how fast you want to make progress are the top variables for determining budget.",
          },
        ],
      },
      {
        q: "How do I gauge ROI of SEO, and what are reasonable returns for SEO?",
        a: [
          {
            type: "p",
            text: "True SEO ROI can show you the effectiveness of any SEO campaign. The main things that will reflect the effectiveness of your SEO efforts are the following:",
          },
          {
            type: "ul",
            items: [
              "Subscriptions",
              "Repeat traffic",
              "New traffic",
              "Community involvement",
              "Registrations",
            ],
          },
        ],
      },
    ],
  },
  {
    id: "geo-aio",
    title: "GEO & AIO Optimization",
    faqs: [
      {
        q: "What are GEO and AIO in plain English?",
        a: [
          {
            type: "p",
            text: "GEO (Generative Engine Optimization) is the work of getting your business named when people ask AI assistants — ChatGPT, Gemini, Claude — who the best option in their city is. AIO (AI Overview Optimization) is the same idea for Google's AI Overviews: the AI-written answer at the top of many Google results. Same discipline, two places your customers now look first.",
          },
        ],
      },
      {
        q: "How do I get my business to show up in AI answers?",
        a: [
          {
            type: "p",
            text: "The AI quotes the sources it has seen and trusted longest. That means a website the crawlers can fully read, consistent business listings across the web, fresh content published off your site, and real reviews. We build all of it for you — it is the core of our SEO + AI Visibility program.",
          },
        ],
      },
      {
        q: "Is GEO replacing SEO?",
        a: [
          {
            type: "p",
            text: "No — the AI answers are built on top of search. The same authority and content that rank you on Google are what the AI engines draw from. That is exactly why we run SEO and GEO together in one program, instead of as two separate battles.",
          },
        ],
      },
      {
        q: "How long until AI mentions my business?",
        a: [
          {
            type: "p",
            text: "AI mentions often move faster than classic rankings, because the field is wide open — most businesses are not in the answers yet. Expect first movement within 60 to 90 days, tracked on your dashboard month over month so nothing is taken on faith.",
          },
        ],
      },
      {
        q: "How do I check if AI recommends my business today?",
        a: [
          {
            type: "p",
            text: "Ask ChatGPT, Gemini or Claude \"who's the best [your trade] in [your city]?\" and write down who gets named — then ask again next month. Better: our dashboard tracks those mentions for your target searches every month and shows you the movement.",
          },
        ],
      },
    ],
  },
  {
    id: "social-media",
    title: "Social Media Advertising",
    faqs: [
      {
        q: "How does social media help my business?",
        a: [
          {
            type: "ul",
            items: [
              "Social networking makes relationships more personal",
              "You can promote your business more effectively",
              "You get valuable insights about your audience and your business",
              "Social networking induces loyalty",
              "Social media increases website traffic",
            ],
          },
        ],
      },
      {
        q: "What if I don't have time for social media?",
        a: [
          {
            type: "p",
            text: "If you are too busy and literally don't have the time to manage and implement a social media presence, then hiring an agency to handle your social media would definitely be a wise decision. By hiring a reputable and proven agency, you can be sure that they are managing everything and making all of your social media posts count.",
          },
        ],
      },
      {
        q: "How much social media do I need?",
        a: [
          {
            type: "p",
            text: "You should utilize the platforms that will give you the largest reach for your efforts. Facebook, Twitter, Instagram, LinkedIn, Pinterest, and YouTube are the largest platforms today. Using all of them would be the best way to reach your customers and future customers. There are many factors that you should consider when you decide to launch your social media campaign.",
          },
        ],
      },
      {
        q: "How much should I spend on social media advertising?",
        a: [
          {
            type: "p",
            text: "Before you set a budget for advertising on social media, learn about your industry and your audience. Advertising on social media is the most cost-effective way to reach certain audiences. Most social media accounts offer advertising, and the budget that might be set — or what platform to focus on — is determined by having a social media audit done for your business. It takes a professional that understands where your audience is on social media and how to reach them, so the cost and budget for your social media advertising would be determined by a variety of factors.",
          },
        ],
      },
      {
        q: "Can I do social media myself or do I have to outsource?",
        a: [
          {
            type: "p",
            text: "You can of course do all of your own social media, but there are things to consider if you decide to do it yourself. Some of the main reasons for hiring an agency to handle your social media are:",
          },
          {
            type: "ul",
            items: [
              "Strategy and planning",
              "Consistent planned publishing",
              "Management of your strategy",
              "Knowing when, where and how to publish content",
            ],
          },
        ],
      },
    ],
  },
  {
    id: "paid-ads",
    title: "Paid Ads: Google Ads & Facebook",
    faqs: [
      {
        q: "What is better: Facebook advertising or Google Ads?",
        a: [
          {
            type: "p",
            text: "Both are advertising platforms that operate on a pay-per-click basis. You place a bid for how much you want to pay for that ad, then you'll be charged a certain amount of money every time someone clicks one of your ads. Facebook ads tend to cost less per click than Google Ads.",
          },
          { type: "p", text: "With Facebook Ads you can advertise on:" },
          {
            type: "ul",
            items: [
              "Facebook News Feed",
              "Instagram",
              "Audience Network",
              "Facebook Messenger",
            ],
          },
          { type: "p", text: "With Google Ads you can advertise on:" },
          {
            type: "ul",
            items: [
              "Google Search",
              "YouTube",
              "Google Display Network",
              "Google Maps",
              "Google Play",
            ],
          },
        ],
      },
      {
        q: "How much is a Google Ads campaign?",
        a: [
          {
            type: "p",
            text: "There is no easy, one-size-fits-all answer to this question — it all depends on many variables. It is based on an auction system. If a business has a high quality ad campaign, they get lower costs and better ad placements. The budget you choose for your campaign will determine how much you can afford to pay per click.",
          },
        ],
      },
      {
        q: "What should a CPC budget be for Google Ads or Facebook?",
        a: [
          {
            type: "p",
            text: "Facebook ads have an average cost-per-click (CPC) of $1.86 and cost-per-thousand-views (CPM) of $11.20, and there is no minimum monthly ad spend, making Facebook affordable for most businesses. For Google Ads, you can roughly calculate your test budget by multiplying the number of keywords you want to test by the cost per click and by a minimum of 100 clicks. So, for example, if you're going to test 10 keywords with a cost per click of $1, we'd recommend you plan on a test budget of $1,000 to $2,000.",
          },
        ],
      },
      {
        q: "Does advertising online really help my business?",
        a: [
          {
            type: "p",
            text: "Absolutely. Online advertising is fast, flexible, and trackable:",
          },
          {
            type: "ul",
            items: [
              "Drive traffic to your website & increase conversions",
              "Increase brand awareness, credibility & trust",
              "Promote to your specific target markets",
              "Re-engage previous prospects with re-targeting ads",
              "Lower your marketing costs",
              "Your competitors are doing it",
            ],
          },
        ],
      },
      {
        q: "What ways can Facebook advertising help my business?",
        a: [
          {
            type: "p",
            text: "One of the main benefits of advertising on Facebook is that it allows you to run advertising campaigns that are tailored and targeted at specific parameters that you choose. Facebook ads can increase brand awareness, capture solid leads, and have a huge reach to a vast audience.",
          },
        ],
      },
      {
        q: "How do Google Ads help me get the phone to ring?",
        a: [
          {
            type: "p",
            text: "Google Ads help get the phone to ring in several ways:",
          },
          {
            type: "ul",
            items: [
              "Google Ads increase leads and customers",
              "It's a flexible marketing platform",
              "Businesses get a high return on investment",
              "You see fast, transparent results",
              "It taps into huge, high quality traffic sources",
              "Businesses find out more about their market",
            ],
          },
        ],
      },
    ],
  },
  {
    id: "website-optimization",
    title: "Website Optimization",
    faqs: [
      {
        q: "What is website optimization?",
        a: [
          {
            type: "p",
            text: "Website optimization improves your customer experience and boosts rankings. It's important that visitors to your site can do two things right away: know what the page they land on is about, and easily find the information they're looking for. These indicate to search engines that your page is meeting customer needs, which in turn boosts your ability to rank higher and drive more traffic.",
          },
        ],
      },
      {
        q: "How will website optimization help my website?",
        a: [
          {
            type: "p",
            text: "When your website isn't found by search engines, business is lost. Professional SEO services can help you increase your site's relevance and, in turn, move it higher in the rankings — putting your products and services closer to potential customers. With its ability to generate more quality traffic to your website at a relatively low cost, search engine optimization is an essential part of your online marketing strategy.",
          },
        ],
      },
      {
        q: "What is a landing page or lead page?",
        a: [
          {
            type: "p",
            text: "Optimizing your website means optimizing the entry or landing pages where visitors first come into contact with your site. Whether they come from Google, Facebook or somewhere else, the landing page is where people make an initial decision on whether you can help them with their needs.",
          },
        ],
      },
      {
        q: "Why do I need fresh web pages and new content?",
        a: [
          {
            type: "p",
            text: "Your business is important to you and you want your clients to know that. A boring and hard to navigate website can scare clients away before they know what you are about. You want to be sure that you put your best foot forward when seeking out new clients. Keeping your website up to date is one of the most important ways to accomplish this for your business.",
          },
        ],
      },
      {
        q: "What is a CTA (call to action)?",
        a: [
          {
            type: "p",
            text: "A call to action (CTA) is a marketing term that refers to the next step a marketer wants its audience or reader to take. The CTA can have a direct link to sales — for example, it can instruct the reader to click the buy button to complete a sale, or it can simply move the audience further along towards becoming a consumer of that company's goods or services. The CTA can suggest that the reader subscribe to a newsletter that contains product updates, for example. To be effective, a CTA should be obvious and should immediately follow the marketing message.",
          },
        ],
      },
    ],
  },
];
